export var ProtectionSupplierTypeEnum;
(function (ProtectionSupplierTypeEnum) {
    ProtectionSupplierTypeEnum["RACIAL_TRAIT"] = "RACIAL_TRAIT";
    ProtectionSupplierTypeEnum["CLASS_FEATURE"] = "CLASS_FEATURE";
    ProtectionSupplierTypeEnum["FEAT"] = "FEAT";
    ProtectionSupplierTypeEnum["ITEM"] = "ITEM";
})(ProtectionSupplierTypeEnum || (ProtectionSupplierTypeEnum = {}));
export var ProtectionAvailabilityStatusEnum;
(function (ProtectionAvailabilityStatusEnum) {
    ProtectionAvailabilityStatusEnum["AVAILABLE"] = "AVAILABLE";
    ProtectionAvailabilityStatusEnum["NO_LIMITED_USE_REMAINING"] = "NO_LIMITED_USE_REMAINING";
    ProtectionAvailabilityStatusEnum["ITEM_NOT_EQUIPPED"] = "ITEM_NOT_EQUIPPED";
    ProtectionAvailabilityStatusEnum["ITEM_NOT_ATTUNED"] = "ITEM_NOT_ATTUNED";
})(ProtectionAvailabilityStatusEnum || (ProtectionAvailabilityStatusEnum = {}));
